import { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useResponsiveness } from 'hooks/useResponsiveness';
import { PageContainer, PageContent } from 'components';
import { Control } from './Control';

export const Header = () => {
  const [isFloatingHeaderVisible, setIsFloatingHeaderVisible] = useState(false);

  const intersectionObserver = useRef<IntersectionObserver>();
  const controlRef = useRef<HTMLFormElement>(null);

  const { isMobile } = useResponsiveness();

  useEffect(() => {
    if (!controlRef.current) return;

    if (!isMobile) {
      if (intersectionObserver.current) {
        intersectionObserver.current?.disconnect();

        intersectionObserver.current = undefined;
      }

      return;
    }

    intersectionObserver.current = new IntersectionObserver(([entry]) => {
      setIsFloatingHeaderVisible(!entry.isIntersecting);
    });

    intersectionObserver.current.observe(controlRef.current);

    return () => {
      intersectionObserver.current?.disconnect();
    };
  }, [intersectionObserver.current, controlRef.current, isMobile]);

  return (
    <>
      <Control ref={controlRef} />

      <AnimatePresence>
        {isFloatingHeaderVisible && (
          <PageContainer
            as={motion.div}
            initial={{ top: '-100%', opacity: 0 }}
            animate={{ top: 0, opacity: 1 }}
            exit={{ top: '-100%', opacity: 0 }}
            pos="fixed"
            top={0}
            left={0}
            zIndex={15}
            bg="white"
            shadow="lg"
          >
            <PageContent py="1rem">
              <Control />
            </PageContent>
          </PageContainer>
        )}
      </AnimatePresence>
    </>
  );
};
